import { Component, OnInit, Input } from '@angular/core';
import { ContextService } from '../context.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'mutara-message-bar',
    template: `<span [innerHtml]="message"></span>`,
    standalone: false
})
export class MessageBarComponent implements OnInit {
  @Input() message: SafeHtml | undefined;

  constructor(private context: ContextService, private sanitizer: DomSanitizer) { 
  }

  ngOnInit(): void {
    this.context.subscribeTo("messageSource",(messageText : string) => {
      this.message = this.sanitizer.bypassSecurityTrustHtml(messageText);
    });
  }

}